import React from 'react';
import {
  Formik,
  Form,
} from 'formik';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

import { useTranslation } from 'react-i18next';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import {
  initFormValues,
} from '~/commons/helpers';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';
import FieldFileSlider from '~/commons/components/FieldFileSlider.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';

const defaultCollapsible = {
  header: '',
  content: '',
};
const defaults = {
  title: '',
  description: '',
  coverImg: null,
  content: '',
  slider: [],
  collapsibles: [],
  redirect: '',
};

const FormViewSlot = ({
  viewSlot,
}) => {
  const [res, req] = useHttpStatus();
  const { format } = viewSlot;
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initFormValues(defaults, viewSlot)}
      onSubmit={async (values, actions) => {
        const { status } = await req({
          method: 'patch',
          url: `/api/site/view-slots/${viewSlot._id}`,
          data: {
            ...values,
            coverImg: typeof values.coverImg === 'string'
              ? values.coverImg : '',
            slider: values.slider.filter((s) => typeof s === 'string'),
          },
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values });
        }
      }}
    >
      <Form>
        <FormHttpSaveBtn
          res={res}
          className="btn-primary mb-3"
          disabled={false}
        />
        <FormHttpAlert res={res} />
        {format === 'slider' && (
          <>
            <FieldFileSlider
              name="slider"
              api="/api/site/view-slots/files"
            />
          </>
        )}
        {(format === 'page' || format === 'slot') && (
          <>
            <FormGroup name="title" label={t('Title')} />
            {format === 'page' && (
              <>
                <FormGroup
                  name="description"
                  label={t('Description')}
                  helpText={t('A short description of the page')}
                />
                <FormGroup
                  name="coverImg"
                  label={t('Cover Image')}
                  as="coverImg"
                  api="/api/site/view-slots/files"
                />
              </>
            )}
            <FormGroup
              name="content"
              label={t('Content')}
              as="summernote"
              fileUploadUrl="/api/site/view-slots/files"
            />
          </>
        )}
        {(format === 'page' || format === 'collapsibles') && (
          <div className="form-group">
            <label>{t('Collapsibles')}</label>
            <FieldArrayIterables
              name="collapsibles"
              push={defaultCollapsible}
            >
              {(c, i, { remove }) => (
                <div
                  key={i}
                  className="card px-4 py-3 mb-4"
                >
                  <button
                    className="btn btn-link close"
                    onClick={() => remove(i)}
                  >
                    <FA icon={faTimes} size="sm" />
                  </button>
                  <FormGroup
                    name={`collapsibles.${i}.header`}
                    label={t('Header')}
                  />
                  <FormGroup
                    name={`collapsibles.${i}.content`}
                    label={t('Content')}
                    as="summernote"
                    fileUploadUrl="/api/site/view-slots/files"
                  />
                </div>
              )}
            </FieldArrayIterables>
          </div>
        )}
        {(format === 'redirect') && (
          <>
            <FormGroup
              name="redirect"
              label='Redirect URL'
            />
          </>
        )}
      </Form>
    </Formik>
  );
};

export default FormViewSlot;
